module.exports = __webpack_public_path__ + "static/media/FrameYellow.741f20c3.png";